module.exports = __webpack_public_path__ + "img/slim_cleanstation11.129768b3.jpg";